import { render } from "./orderDetail.vue?vue&type=template&id=4292e6de"
import script from "./orderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./orderDetail.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/orderDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4292e6de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4292e6de', __exports__)) {
    console.log('reload')
    api.reload('4292e6de', __exports__)
  }
  
  module.hot.accept("./orderDetail.vue?vue&type=template&id=4292e6de", () => {
    console.log('re-render')
    api.rerender('4292e6de', render)
  })

}


export default __exports__